import {useEffect, useRef, useState} from "react";

/**
 * Returns a ref to attach to a DOM element and its current width.
 * Automatically updates on resize using ResizeObserver.
 */
export function useContainerWidth(): [React.RefObject<HTMLDivElement>, number] {
    const ref = useRef<HTMLDivElement>(null);
    const [width, setWidth] = useState(0);

    useEffect(() => {
        const element = ref.current;
        if (!element) {
            return;
        }

        const observer = new ResizeObserver(([entry]) => {
            setWidth(entry.contentRect.width);
        });

        observer.observe(element);

        return () => {
            observer.disconnect();
        };
    }, []);

    return [ref, width];
}
